<div class="flex min-w-0 flex-1 flex-col">
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [hideSearch]="true"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-notifications-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>

            @switch (column.key) {
              @case ('title') {
                <td mat-cell *matCellDef="let notification" class="font-medium text-gray-12">
                  {{ notification.title }}
                </td>
              }
              @case ('message') {
                <td
                  mat-cell
                  *matCellDef="let notification"
                  class="text-gray-11 max-w-xs truncate"
                  [matTooltip]="notification.message"
                >
                  {{ notification.message }}
                </td>
              }
              @case ('type') {
                <td mat-cell *matCellDef="let notification">
                  @switch (notification.type) {
                    @case ('SUCCESS') {
                      <aura-simple-chip
                        [text]="'Succès'"
                        class="bg-green-2 text-green-9 border-green-3 border"
                      />
                    }
                    @case ('WARNING') {
                      <aura-simple-chip
                        [text]="'Avertissement'"
                        class="bg-amber-2 text-amber-9 border-amber-3 border"
                      />
                    }
                    @case ('ERROR') {
                      <aura-simple-chip [text]="'Erreur'" class="bg-red-2 text-red-9 border-red-3 border" />
                    }
                    @case ('SYSTEM') {
                      <aura-simple-chip
                        [text]="'Système'"
                        class="bg-purple-2 text-purple-9 border-purple-3 border"
                      />
                    }
                    @default {
                      <aura-simple-chip [text]="'Info'" class="bg-blue-2 text-blue-9 border-blue-3 border" />
                    }
                  }
                </td>
              }
              @case ('read') {
                <td mat-cell *matCellDef="let notification">
                  @if (notification.read) {
                    <span class="inline-flex items-center gap-1.5 text-xs font-medium text-gray-9">
                      <span class="h-1.5 w-1.5 rounded-full bg-gray-5"></span>
                      Lu
                    </span>
                  } @else {
                    <span class="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-11">
                      <span class="h-1.5 w-1.5 rounded-full bg-primary-9"></span>
                      Non lu
                    </span>
                  }
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let notification">
                  {{ notification.createdAt | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @case ('context') {
                <td mat-cell *matCellDef="let notification">
                  @if (notification.user) {
                    <button
                      [matTooltip]="'Utilisateur'"
                      [routerLink]="['/users', notification.user._id]"
                      mat-button
                      class="link flex flex-row items-center"
                    >
                      <aura-avatar
                        [label]="$safeNavigationMigration(notification.user.identity?.firstName)"
                        [srcImage]="$safeNavigationMigration(notification.user.identity.avatar?.url)"
                        [size]="'xs'"
                      />

                      <div class="ml-2">
                        {{ $safeNavigationMigration(notification.user.identity?.firstName) | titlecase }}
                        {{ $safeNavigationMigration(notification.user.identity?.lastName) | titlecase }}
                      </div>
                    </button>
                  } @else {
                    <span class="text-gray-9 italic">Inconnu</span>
                  }
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let notification">
                  {{ notification[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
